import { render } from "./SearchFrameTopics.vue?vue&type=template&id=0c02df78"
import script from "./SearchFrameTopics.vue?vue&type=script&lang=js"
export * from "./SearchFrameTopics.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__